// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"Checkbox_checkboxWrapper__ot49E","checked":"Checkbox_checked__Ba8P1","gray":"Checkbox_gray__oXR6z"};